import styled from 'styled-components';

export const WrapperLoader = styled.div`
  text-align: center;
  margin-top: 130px;
  background-color: transparent;
  min-height: 100vh;
`;